/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Review.Api
 * OpenAPI spec version: 1.0
 */

export type Pillar2FilingOperationStep = (typeof Pillar2FilingOperationStep)[keyof typeof Pillar2FilingOperationStep];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Pillar2FilingOperationStep = {
    Submit: 'Submit',
    CloudStorage: 'CloudStorage',
} as const;
